import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PageTitle } from 'components';
import NewClaimIcon from 'assets/images/home/new-claim.svg';

import { StretchedSpace } from './components';

const WeCareLoginPage = () => {
  const { t } = useTranslation();

  return (
    <StretchedSpace direction="vertical" size={16}>
      <PageTitle icon={NewClaimIcon} title={t('migration.existingMemberTitle')} alt="we care login" />
      <Outlet />
    </StretchedSpace>
  );
};

export default WeCareLoginPage;
